export const SETOOLDATA = 'setToolData';
export const SETCACHEVIEW = 'setCacheView';
export const CLEARTOOLITEM = 'clearToolItem';
export const CLEARCACHEVIEW = 'clearCacheView';
export const SETPERSONALDATA = 'setPersonalData';
